module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/plan4-1-e132eaa9f0751f7073fb99b24a65c6c4.webp";